'use client';

import { Search, X } from 'lucide-react';
import { useRef } from 'react';
import { useTotem } from '@/app/(users)/totem-by-slug/[slug]/providers/totem-provider';

export function TotemSearchPill() {
  const { searchQuery, setSearchQuery } = useTotem();
  const searchInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="w-full bg-background shrink-0 px-4 pt-4 pb-1 sm:px-6 sm:pt-6 sm:pb-1">
      <div className="relative flex items-center w-full">
        <Search className="absolute left-4 size-5 text-muted-foreground pointer-events-none" strokeWidth={1.8} />
        <input
          ref={searchInputRef}
          type="text"
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          placeholder="Buscar productos..."
          className="h-[42px] w-full rounded-full border-none bg-gray-100 dark:bg-muted/50 pl-12 pr-12 text-base outline-none transition-all duration-300 placeholder:font-medium placeholder:text-muted-foreground focus:ring-2 focus:ring-primary/20"
        />
        {searchQuery && (
          <button
            type="button"
            onClick={() => {
              setSearchQuery('');
              searchInputRef.current?.focus();
            }}
            className="absolute right-3 p-2 text-muted-foreground hover:bg-muted/50 rounded-full transition-colors"
          >
            <X className="size-5" />
          </button>
        )}
      </div>
    </div>
  );
}
